/**
 * 全局过滤器
 */
let isEmpty = (value, replace = '未填写') => {
    if (value === null || value === undefined || value === '') {
        return replace;
    }

    return value;
}
/**
 * 时分秒转换
 * @param {} value 
 */
function formatSeconds(value) {
    var theTime = parseInt(value);// 秒
    var middle = 0;// 分
    var hour = 0;// 小时

    if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
        }
    }
    var result = "" + parseInt(theTime) + "秒";
    if (middle > 0) {
        result = "" + parseInt(middle) + "分" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
    }
    return result;
}

// 时分秒转换
function formateSection2(value) {
    var theTime = parseInt(value);// 秒
    var middle = 0;// 分
    var hour = 0;// 小时

    if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
        }
    }
    var result = "" + parseInt(theTime);
    if (middle > 0) {
        result = "" + parseInt(middle) + ":" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + ":" + result;
    }
    return result;
}

// 格式化手机号
function formatPhone(val) {
    if (val) {
        val = val.toString();
        return val.substring(0, 3) + "****" + val.substring(7, 11);
    }
    return '';

}

// 格式化身份证号
function formatIdCard(val) {
    if (val) {
        val = val.toString();
        return val.substring(0, 3) + "****" + val.substring(14, 18);
    }

    return '';
}

export {
    formatSeconds,
    formateSection2,
    isEmpty,
    formatPhone,
    formatIdCard
}